goog.require('el8.appservice.status');

var el8 = el8 || {};
if (!el8.main) { el8.main = {}; }
el8.main.fullscreenXmlSummary = {};


el8.main.fullscreenXmlSummary.init = function(spec) {

    el8.appservice.status.init();

    var xmlUrl = spec.xmlUrl;
    var xslUrl = spec.xslUrl;
    // var xmlUrl = "/patient/342753281/xml-summary/56821285179/xml/";
    // var xslUrl = "/patient/342753281/xml-summary/56821285179/xsl/";

    // Just returns an AJAX requests that can be passed in to the $.when clause
    var asyncLoadXMLDoc = function(filename) {
        return $.el8_ajax({
            type: 'GET',
            url: filename,
            dataType: 'xml',
            async: true
        });
    };

    // waits until both async requests return to do anything (http://api.jquery.com/jQuery.when/)
    $.when( asyncLoadXMLDoc(xmlUrl), asyncLoadXMLDoc(xslUrl) ).done(function(a1, a2) {
        var xml = a1[0]; // format of a1/a2: [ data, statusText, jqXHR ]
        var xsl = a2[0];

        var xsltProcessor = new XSLTProcessor();
        xsltProcessor.importStylesheet(xsl);
        var resultDocument = xsltProcessor.transformToFragment(xml, document); // transformed HTML as a DocumentFragment
        
        var serializer = new XMLSerializer();
        var htmlStr = serializer.serializeToString(resultDocument); // transformed HTML as String
        
        $('body').html(htmlStr).css('overflow', 'auto');
    });

};

